import React from "react";
import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import Button from "src/components/Button/Button";
import EventFinished from "src/components/EventFinished";
import DiningCarousel from "src/components/Restaurants/DiningCarousel";
import TitleSection from "src/components/TitleSection/TitleSection";

const Valentines2026 = () => {
  const { t, i18n } = useTranslation();

  const restaurantSlides = [
    {
      id: 1,
      title: "DD Sashimi-Maki",
      image:
        "entertainment/variety/valentines_2026/carousel-DD-Sushi-733x1200-26-01-16.jpg",
      url: t("dining.dining.drunkenDragon.link"),
    },
    {
      id: 2,
      title: "DD Yakitori",
      image:
        "entertainment/variety/valentines_2026/carousel-DD-Meal-733x1200-26-01-16.jpg",
      url: t("dining.dining.drunkenDragon.link"),
    },
    {
      id: 3,
      title: "ETC Salad",
      image:
        "entertainment/variety/valentines_2026/carousel-etc-salad-733x1200-26-01-16.jpg",
      url: t("dining.dining.etc.link"),
    },
    {
      id: 4,
      title: "Dessert",
      image:
        "entertainment/variety/valentines_2026/carousel-etc-dessert-733x1200-26-01-16.jpg",
      url: t("dining.dining.etc.link"),
    },
    {
      id: 5,
      title: "ETC Filet Mignon",
      image:
        "entertainment/variety/valentines_2026/carousel-filet-mignon-733x1200-26-01-16.jpg",
      url: t("dining.dining.etc.link"),
    },
    {
      id: 6,
      title: "Wine",
      image: "entertainment/variety/valentines_2026/carousel-wine-733x1200.jpg",
      url: t("dining.dining.etc.link"),
    },
  ];

  return (
    <Div>
      <Hero
        bgImage="entertainment/variety/valentines_2026/PG-Valentines-day-header-2400x800.jpg"
        title={t("valentines2026.title")}
        fluidImage
      />
      <EventFinished
        scheduleKeyName="valentines2026"
        eventType="entertainment"
      />

      <MainContentDiv>
        <container-div>
          <ResponsiveImage
            src={t("valentines2026.logo")}
            alt="valentines-logo-2026"
            customStyles={{ width: "500px", margin: "0 auto", height: "220px" }}
          />
          <TitleSection
            title={t("valentines2026.content.title")}
            text={t("valentines2026.content.subtitle")}
            borderColor="#E19691"
            dark={false}
          />

          {/* Michael Buble Section */}
          <Row className="m-0 p-0 d-flex justify-content-center">
            <Row xs={1} sm={2} className="p-0 mb-4 box">
              <Col className="m-0 p-4 d-flex flex-column justify-content-center">
                <ResponsiveImage
                  className="radius-mask"
                  src={`entertainment/variety/valentines_2026/Micheal_Buble-SoldOut-${i18n.language}.jpg`}
                  alt="An Evening of Michael Bublé"
                />
              </Col>
              <Col className="m-0 p-4 d-flex flex-column justify-content-center">
                <Row className="m-2">
                  <SubTitleSection
                    subTitle={t("valentines2026.content.buble.title")}
                    text={t("valentines2026.content.buble.text")}
                    borderColor="#E19691"
                  />
                  <Button
                    bgColor="var(--white)"
                    color="var(--red)"
                    hoverBgColor="var(--black)"
                    hoverColor="var(--white)"
                    href={`${window.location.origin}/pdf/VALENTINES-BUFFET-MENU-26-01-27-${i18n.language}.pdf`}
                    label={t("button.view-full-menu")}
                    width="wide"
                    size="medium"
                  />
                  <ReactMarkdown>
                    {t("valentines2026.content.buble.textTwo")}
                  </ReactMarkdown>
                </Row>
              </Col>
            </Row>

            {/* Cupid Section */}
            <Row
              xs={1}
              sm={2}
              className="m-0 mb-4 p-0 d-flex justify-content-center box"
            >
              <Col className="m-0 p-4 d-flex flex-column justify-content-center">
                <Row className="m-2">
                  <SubTitleSection
                    subTitle={t("valentines2026.content.cupid.title")}
                    text={t("valentines2026.content.cupid.text")}
                    borderColor="#E19691"
                  />
                </Row>
              </Col>
              <Col className="m-0 p-4 d-flex flex-column justify-content-center">
                <ResponsiveImage
                  className="radius-mask"
                  src="entertainment/variety/valentines_2026/Cupid-508x318-26-01-16.jpg"
                  alt="Cupid's Free Play"
                />
              </Col>
            </Row>

            <TitleSection
              as="h3"
              title={t("valentines2026.content.dining.title")}
              text={t("valentines2026.content.dining.subtitle")}
              borderColor="#E19691"
              dark={false}
            />
            <div className="radius-mask">
              <DiningCarousel slides={restaurantSlides} />
            </div>
          </Row>

          <TitleSection
            as="h2"
            title={t("valentines2026.content.tabledhote.title")}
            text={t("valentines2026.content.tabledhote.description")}
            borderColor="#E19691"
            dark={false}
          />

          {/* Drunken Dragon Menu Section */}
          <Row
            xs={1}
            sm={2}
            className="m-0 mb-4 p-0 d-flex justify-content-center box"
          >
            <Col className="m-0 p-4 d-flex flex-column justify-content-center">
              <ResponsiveImage
                className="radius-mask"
                src="entertainment/variety/valentines_2026/Drunken-dragon-508x318-26-01-16.jpg"
                alt="Drunken Dragon"
              />
            </Col>
            <Col className="m-0 p-4 d-flex flex-column justify-content-center">
              <Row className="m-2">
                <SubTitleSection
                  subTitle={t(
                    "valentines2026.content.tabledhote.dd.sashimi.title",
                  )}
                  text={t("valentines2026.content.tabledhote.dd.sashimi.text")}
                  borderColor="#E19691"
                />
                <SubTitleSection
                  subTitle={t(
                    "valentines2026.content.tabledhote.dd.yakitori.title",
                  )}
                  text={t("valentines2026.content.tabledhote.dd.yakitori.text")}
                  borderColor="#E19691"
                />
                <Button
                  bgColor="var(--white)"
                  color="var(--red)"
                  hoverBgColor="var(--black)"
                  hoverColor="var(--white)"
                  href={t("dining.dining.drunkenDragon.buttons.reserve.link")}
                  label={t("button.reserve-now")}
                  width="wide"
                  size="medium"
                />
              </Row>
            </Col>
          </Row>

          {/* ETC Menu Section */}
          <Row
            xs={1}
            sm={2}
            className="m-0 mb-4 p-0 d-flex justify-content-center d-reverse box"
          >
            <Col className="m-0 p-4 d-flex flex-column justify-content-center">
              <ResponsiveImage
                className="radius-mask"
                src="entertainment/variety/valentines_2026/etc-508x318-26-01-16.jpg"
                alt="etc"
              />
            </Col>
            <Col className="m-0 p-4 d-flex flex-column justify-content-center">
              <Row className="m-0">
                <SubTitleSection
                  subTitle={t(
                    "valentines2026.content.tabledhote.etc.beets.title",
                  )}
                  text={t("valentines2026.content.tabledhote.etc.beets.text")}
                  borderColor="#E19691"
                />
              </Row>
              <Row className="m-0">
                <SubTitleSection
                  subTitle={t(
                    "valentines2026.content.tabledhote.etc.landAndSea.title",
                  )}
                  text={t(
                    "valentines2026.content.tabledhote.etc.landAndSea.text",
                  )}
                  borderColor="#E19691"
                />
                <Button
                  bgColor="var(--white)"
                  color="var(--red)"
                  hoverBgColor="var(--black)"
                  hoverColor="var(--white)"
                  href={t("dining.dining.etc.buttons.reserve.link")}
                  label={t("button.reserve-now")}
                  width="wide"
                  size="medium"
                />
              </Row>
            </Col>
          </Row>

          {/* Dessert Section */}
          <Row
            xs={1}
            sm={2}
            className="m-0 p-0 mb-4 d-flex justify-content-center box"
          >
            <Col className="m-0 p-4 d-flex flex-column justify-content-center">
              <ResponsiveImage
                className="radius-mask"
                src="entertainment/variety/valentines_2026/Etc-Dessert-508x318-26-01-16.jpg"
                alt="dessert"
              />
            </Col>
            <Col className="m-0 p-4 d-flex flex-column justify-content-center">
              <ReactMarkdown>
                {t("valentines2026.content.tabledhote.dessert.intro")}
              </ReactMarkdown>
              <SubTitleSection
                subTitle={t("valentines2026.content.tabledhote.dessert.title")}
                text={t("valentines2026.content.tabledhote.dessert.text")}
                borderColor="#E19691"
              />
            </Col>
          </Row>

          {/* Closing Section */}
          <TitleSection
            as="h3"
            title={t("valentines2026.content.closing.title")}
            text={t("valentines2026.content.closing.text")}
            borderColor="#E19691"
            dark={false}
          />
        </container-div>
      </MainContentDiv>
    </Div>
  );
};

const Div = styled.div`
  width: 100%;
  height: auto;
  color: var(--white);
  h2 {
    font-size: 1.2rem;
  }
  .hero_container {
    min-height: 400px;
  }
  .subtitle-section {
    padding: 0;
    h2 {
      font-size: 1.2rem;
    }
    p {
      padding: 0;
      font-size: 1rem;
    }
  }
  .radius-mask {
    border-radius: 16px;
    & > div {
      padding-top: 0;
    }
  }
  .slick-track {
    border-radius: 24px;
    overflow: hidden;
  }
  .hero_text_container {
    display: none;
  }
  .box {
    background-color: rgb(160, 46, 51);
    border-radius: 24px;
    padding: 0.5rem;
  }
  .title-section {
    ul {
      li {
        text-align: left;
      }
    }
  }
  @media (min-width: 768px) {
    .hero_container {
      min-height: 800px;
    }
    .d-reverse {
      flex-direction: row-reverse;
    }
  }
`;

const MainContentDiv = styled.div`
  /* background: ${(props) => `url(${props.bgImage})`}; */
  /* @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  text-align: left; */
`;

export default Valentines2026;
